<div class="modal-header">
    Invio documenti al Sistema di Interscambio
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close()" >
          <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body" >
    <ng-container *ngIf="!afterSend">
        <table class="table table-sm table-striped" style="height: 5rem; max-height:60vh" >
            <thead class="" >
                <!-- <th>Tipo</th> -->
                <th>Num.</th>
                <th>Data</th>                
                <th>Cliente</th>
                <th>Importo</th>
                <th class="text-center">Stato SdI</th>
                <th class="text-center">Verifica
                    <i class="fa fa-sync ml-1 pointer" title="Aggiorna" (click)="checkDocuments()"></i>
                </th>
                <th></th>
            </thead>
            <tbody>              
                <ng-container *ngFor="let record of documents">
                    <tr [class.text-gray]="record.sdi_message"
                        *ngIf="(record.typedocument==1 || record.typedocument==2 || record.typedocument==12 || record.typedocument==3) &&
                                (record.sdi_status==0 || record.sdi_status==-1 || record.sdi_status==3)">
                        <!-- <td>
                            <span *ngIf="record.typedocument==1"  title="Fattura" class="badge bg-olive">FS</span>
                            <span *ngIf="record.typedocument==2"  title="Fattura Accompagnatoria" class="badge bg-teal">FV</span>
                            <span *ngIf="record.typedocument==12" title="Fattura Acconto" class="badge bg-lime">FA</span>
                            <span *ngIf="record.typedocument==3"  title="Nota di Credito" class="badge bg-maroon">NC</span>
                        </td>                         -->
                        <td>{{record.reference}} {{record.referenceprefix}}</td>
                        <td>{{record.date| date:"dd/MM/yyyy"}}</td>
                        <td>
                            {{record.addressItem.name}}
                            <span *ngIf="!record.addressItem.sdi && record.addressItem.pec" class="badge border ml-2" title="La fattura non sarà inviata al Sistema di Interscambio, ma verrà indicato solo l'indirizzo PEC">PEC</span>
                        </td>
                        <td>{{record.total | currency:"&euro; "}}</td>
                        <td class="text-center">
                            <i  title="da inviare" *ngIf="record.sdi_status==0 || record.sdi_status==-1" class="text-gray fas fa-paper-plane"></i>
                            <!-- <i  title="Inviata" *ngIf="record.sdi_status==1" class="text-warning fa fa-clock"></i> -->
                            <!-- <i  title="Consegnata" *ngIf="record.sdi_status==2" class="text-success fa fa-check"></i> -->
                            <i  title="Scartata" *ngIf="record.sdi_status==3" class="text-danger fa fa-exclamation-triangle"></i>
                            <!-- <i  title="Confermata ma mancata consegna" *ngIf="record.sdi_status==4" class="text-success fa fa-check"></i> -->
                            <!-- <i  title="Accettata da PA" *ngIf="record.sdi_status==5" class="text-success fa fa-check-double"></i> -->
                            <!-- <i  title="Rifiutata da PA" *ngIf="record.sdi_status==6" class="text-danger fa fa-exclamation-triangle"></i> -->
                        </td>
                        <td class="text-center" style="max-width:16rem; overflow:hidden" >
                            <span *ngIf="record.sdi_message && record.sdi_message.length > 2">
                                <small>{{record.sdi_message.substring(36) | json}}</small>
                            </span>
                            <ng-container *ngIf="VerifyDone">
                                <i  title="Verificato" *ngIf="record.addressItem.role!='PA'" class="text-success fa fa-check-circle"></i>
                                <button *ngIf="record.addressItem.role=='PA'" class="btn btn-outline-primary btn-sm" (click)="viewFatturaElettronica(record)">Firma & Invia</button>
                            </ng-container>                           
                        </td>
                        <td>
                            <button title="Fattura elettronica XML" class="btn btn-primary btn-xs float-right " (click)="viewFatturaElettronica(record)"><i class="fa fa-file-code"></i></button>
                            <button title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right " (click)="VerifyDone=false;openDetail(record)"><i class="fa fa-pencil-alt"></i></button>                           
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>
    <div class="mt-4" *ngIf="afterSend">
        <ng-container >
            <div class="p-5 text-center" *ngIf="total_success>0">
                <i class="fas fa-check fa-2x text-success"></i><br>
                <span *ngIf="total_success>1">{{total_success}} documenti inviati correttamente al Sistema di Interscambio.</span>
                <span *ngIf="total_success==1">Documento inviato correttamente al Sistema di Interscambio.</span>
            </div>                    
            <div class="p-5 text-center" *ngIf="total_errors>0">
                <i class="fas fa-exclamation fa-2x text-warning"></i><br>
                <span *ngIf="total_errors>1">Attenzione: Ci sono {{total_errors}} documenti che presentano problemi nell'invio al Sistema di Interscambio.</span>
                <span *ngIf="total_errors==1">Attenzione: C'è un documento che presenta problemi nell'invio al Sistema di Interscambio.</span><br>
                <br>
                <span>Possibili cause:</span><br>                
                <span>- il documento presenta errori di compilazione non evidenziati dal controllo automatico</span><br>
                <span>- il Sistema di Interscambio è momentaneamente non disponibile o sta riscontrando problemi tecnici</span><br>
                <span>- le credenziali di accesso all'Agenzia delle Entrate non sono corrette o non sono più valide</span>
            </div>
        </ng-container>
    </div>
</div>

<div class="modal-footer">
    <button type="button" *ngIf="!VerifyDone" class="btn btn-outline-primary mr-1" (click)="checkDocuments()">Controlla documenti</button>
    <button type="button" *ngIf="VerifyDone && !afterSend && documentToSend>0" class="btn btn-outline-success mr-1" (click)="sendToSdi()">
        <i class="fas fa-paper-plane blink mr-2"></i>
        <span *ngIf="documentToSend==1">Invia il documento verificato allo SdI</span>
        <span *ngIf="documentToSend>1">Invia i {{documentToSend}} documenti verificati allo SdI</span>
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="close()"><i class="fas fa-times mr-1"></i>Chiudi</button>
</div>